import { render, staticRenderFns } from "./NativeTime.vue?vue&type=template&id=685d922a&scoped=true&"
import script from "./NativeTime.vue?vue&type=script&lang=js&"
export * from "./NativeTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685d922a",
  null
  
)

export default component.exports